import { render, staticRenderFns } from "./Model.vue?vue&type=template&id=71767448&scoped=true"
import script from "./Model.vue?vue&type=script&lang=js"
export * from "./Model.vue?vue&type=script&lang=js"
import style0 from "@/styles/styled_cell.less?vue&type=style&index=0&id=71767448&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71767448",
  null
  
)

export default component.exports